import React, { useContext } from "react";
import SbLoginComponent from "Components/SbLoginComponent/SbLoginComponent";
import SbSignupComponent from "Components/SbSignupComponent/SbSignupComponent";
import SbForgotPasswordComponent from "Components/SbForgotPswdComponent/SbForgotPswdComponent";
import SSOLoginHome from "Pages/SSO/SSOLogin";
import LoginPageLayout from "Pages/SbAuthPage/LoginPageLayout";
import { AuthFunctionsContext } from "State/AuthFunctionsContext";
import { SSO_LOGIN_DOMAINS } from "config/ApiConfig";

// The layout (bg + logo + heading + login-page image) is mounted once here; only the form inside
// it swaps between Login / Sign up / Forgot password — so the image never re-renders.
const SbAuthPage = () => {
  const { isSignup, isForgotPassword } = useContext(AuthFunctionsContext);
  const host = window?.location?.hostname?.toLowerCase();
  const isSSOLoginHost = host?.includes(SSO_LOGIN_DOMAINS?.toLowerCase());

  if (isSSOLoginHost) return <SSOLoginHome />;

  return (
    <LoginPageLayout>
      {isForgotPassword ? (
        <SbForgotPasswordComponent />
      ) : isSignup ? (
        <SbSignupComponent />
      ) : (
        <SbLoginComponent />
      )}
    </LoginPageLayout>
  );
};

export default SbAuthPage;
